export enum AttendanceType {
  day = 0,
  subject = 1,
  session = 2,
}

